import React from "react";

import { Event } from "lib/build/events";

export function useFindEventsByTags(events: Event[], tags: string[]): Event[] {
	return React.useMemo(
		() =>
			tags.length === 0
				? events
				: events.filter(event =>
						tags.some(tagA =>
							event.tagDetails.some(
								tagB => `${tagB.vocab}|${tagB.code}` === tagA
							)
						)
					),
		[events, tags]
	);
}
